// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"db5b6c6b","383":"a82c0b9d"}[chunkId] + ".chunk.js";
};